import { handleSpringDataRequest } from "../../api";

export const PLATFORM_RAZORPAY_KEY_ID_URL =
  "core/api/v1/payments/razorpay/platform-key-id";

/**
 * The platform Razorpay key id from backend-core (IR-2026-09-30), so a rotated
 * key needs no UI rebuild. Resolves to null when the backend cannot say (older
 * backend, network error); callers then keep REACT_APP_RAZORPAY_PUBLIC_KEY.
 */
export const fetchPlatformRazorpayKeyId = () =>
  handleSpringDataRequest(PLATFORM_RAZORPAY_KEY_ID_URL)
    .then((res) => res?.key_id || null)
    .catch((err) => {
      console.warn(
        "Platform Razorpay key id unavailable; using the build-time key:",
        err?.message
      );
      return null;
    });
